import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { LastUsage, UserStatsBundle } from 'src/app/models/statistics';
import { Util } from 'src/app/util';

@Component({
  selector: 'app-user-stats-last-usage-table',
  templateUrl: './user-stats-last-usage-table.component.html',
  styleUrls: ['./user-stats-last-usage-table.component.scss'],
})
export class UserStatsLastUsageTableComponent implements OnInit {
  @Input() userStatsBundle: UserStatsBundle;

  ebookStats: LastUsage;
  audioStats: LastUsage;
  videoStats: LastUsage;
  scormStats: LastUsage;

  constructor(private datePipe: DatePipe) {}

  ngOnInit() {
    this.loadEbookValues();
    this.loadAudioValues();
    this.loadVideoValues();
    this.loadScormValues();
  }

  private formatDate(dateTimestamp: number) {
    if (dateTimestamp === 0) {
      return '--';
    } else {
      const date: string = this.datePipe.transform(dateTimestamp);
      const hourTime: string = this.datePipe.transform(dateTimestamp, 'shortTime');
      return date + ' - ' + hourTime;
    }
  }

  private loadEbookValues() {
    const pagesPerHour = Util.getPagesPerHour(
      this.userStatsBundle.readingStats.ebookPagesRead,
      this.userStatsBundle.readingStats.ebookTimeReading
    );
    this.ebookStats = {
      title:
        this.userStatsBundle.readingStats.ebookTitle !== null ? this.userStatsBundle.readingStats.ebookTitle : '--',
      firstDate: this.formatDate(this.userStatsBundle.readingStats.ebookFirstDate),
      lastDate: this.formatDate(this.userStatsBundle.readingStats.ebookLastDate),
      lastDedicatedHours: Util.formatTime(this.userStatsBundle.readingStats.ebookTimeReading),
      lastUnitsPerHour: isNaN(pagesPerHour) ? '--' : pagesPerHour,
    };
  }

  private loadAudioValues() {
    this.audioStats = {
      title: this.userStatsBundle.listeningStats.title !== null ? this.userStatsBundle.listeningStats.title : '--',
      firstDate: this.formatDate(this.userStatsBundle.listeningStats.firstDate),
      lastDate: this.formatDate(this.userStatsBundle.listeningStats.lastDate),
      lastDedicatedHours: Util.formatTime(this.userStatsBundle.listeningStats.totalReproduced),
    };
  }

  private loadVideoValues() {
    this.videoStats = {
      title: this.userStatsBundle.watchingStats.title !== null ? this.userStatsBundle.watchingStats.title : '--',
      firstDate: this.formatDate(this.userStatsBundle.watchingStats.firstDate),
      lastDate: this.formatDate(this.userStatsBundle.watchingStats.lastDate),
      lastDedicatedHours: Util.formatTime(this.userStatsBundle.watchingStats.totalReproduced),
    };
  }

  private loadScormValues() {
    this.scormStats = {
      title: this.userStatsBundle.scormStats.title !== null ? this.userStatsBundle.scormStats.title : '--',
      firstDate: this.formatDate(this.userStatsBundle.scormStats.firstDate),
      lastDate: this.formatDate(this.userStatsBundle.scormStats.lastDate),
      lastDedicatedHours: Util.formatTime(this.userStatsBundle.scormStats.totalReproduced),
    };
  }
}
